import { useState } from 'react';

import {
  LayoutCard,
  Skeleton,
  ToggleButton,
  ToggleButtonGroup,
} from '@cast/design-system';
import { RffYamlEditor, useRffFormState } from '@cast/shared-rff-ui';
import { notReachable } from '@cast/utils';

import { FIELD_NAMES } from '../_constants';

import { ConfigurationBuilder } from './ConfigurationBuilder';

const ADVANCED_CONFIG_MODES = ['Builder', 'YAML'] as const;
type AdvancedConfigMode = (typeof ADVANCED_CONFIG_MODES)[number];

export const AdvancedConfigurations = () => {
  const [configMode, setConfigMode] = useState<AdvancedConfigMode>('Builder');
  const { mode: formMode } = useRffFormState();

  return (
    <LayoutCard
      testId="evictor-advanced-configurations"
      title="Advanced configurations"
      headerEndContent={
        <ToggleButtonGroup
          size="sm"
          value={configMode}
          onChange={(_event, newMode) => {
            setConfigMode(newMode);
          }}
          exclusive
          testId="evictor-config-mode-toggle"
        >
          {ADVANCED_CONFIG_MODES.map((mode) => (
            <ToggleButton key={mode} value={mode} text={mode} testId={mode} />
          ))}
        </ToggleButtonGroup>
      }
    >
      {(() => {
        switch (configMode) {
          case 'Builder':
            return <ConfigurationBuilder />;
          case 'YAML':
            return (
              <RffYamlEditor
                name={FIELD_NAMES.advancedEvictorConfig}
                disabled={formMode === 'view'}
                testId="advanced-configurations-yaml-editor"
              />
            );
          default:
            return notReachable(configMode);
        }
      })()}
    </LayoutCard>
  );
};

const AdvancedConfigurationsSkeleton = () => {
  return <Skeleton height={200} />;
};

AdvancedConfigurations.Skeleton = AdvancedConfigurationsSkeleton;
